<template>
  <div class="landing-root">
    <div
      ref="hero"
      class="hero"
    >
      <div
        ref="escudo"
        class="hero-escudo"
      >
        <div class="hero-escudo-inner" />
      </div>

      <div
        ref="heroContent"
        class="hero-content"
      >
        <div class="hero-institutional">
          <span class="hero-inst-dot" />
          Universidad Nacional de Córdoba
          <span class="hero-inst-dot" />
        </div>

        <h1 class="hero-logo">
          Usuario <span>UNC</span>
        </h1>

        <p class="hero-subtitle">
          Tu identidad universitaria digital. Un único acceso a todos los sistemas y servicios de la universidad.
        </p>

        <div class="hero-btns">
          <cta-button @click="createUser">
            Crear mi Usuario UNC
          </cta-button>
        </div>
      </div>

      <div
        ref="scrollIndicator"
        class="hero-scroll-indicator"
      >
        <span>Descubrí más</span>
        <div class="scroll-line" />
      </div>
    </div>

    <div
      class="section"
    >
      <div class="section-label reveal-text">
        ¿Qué es Usuario UNC?
      </div>
      <h2 class="section-title reveal-text">
        Tu llave a la universidad
      </h2>

      <p class="section-desc reveal-text">
        Un identificador personal y único que te conecta con todos los recursos digitales de la UNC desde un solo lugar.
      </p>

      <div class="cards-grid">
        <!-- eslint-disable-next-line vuejs-accessibility/mouse-events-have-key-events, vuejs-accessibility/no-static-element-interactions -->
        <div
          class="info-card"
          @mousemove="onCardTilt"
          @mouseleave="resetCardTilt"
        >
          <div class="card-icon">
            <svg
              aria-hidden="true"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
              />
            </svg>
          </div>
          <h3 class="card-title">
            Identidad única
          </h3>
          <p class="card-text">
            Un solo nombre de usuario y contraseña para acceder a todos los sistemas de la Universidad Nacional de
            Córdoba.
          </p>
        </div>

        <!-- eslint-disable-next-line vuejs-accessibility/mouse-events-have-key-events, vuejs-accessibility/no-static-element-interactions -->
        <div
          class="info-card"
          @mousemove="onCardTilt"
          @mouseleave="resetCardTilt"
        >
          <div class="card-icon">
            <svg
              aria-hidden="true"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
          <h3 class="card-title">
            Acceso seguro
          </h3>
          <p class="card-text">
            Tu identidad digital protegida. Accedé a sistemas académicos, administrativos y servicios en la nube de
            forma segura.
          </p>
        </div>

        <!-- eslint-disable-next-line vuejs-accessibility/mouse-events-have-key-events, vuejs-accessibility/no-static-element-interactions -->
        <div
          class="info-card"
          @mousemove="onCardTilt"
          @mouseleave="resetCardTilt"
        >
          <div class="card-icon">
            <svg
              aria-hidden="true"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 3h7v7H3V3zm11 0h7v7h-7V3zM3 14h7v7H3v-7zm11 0h7v7h-7v-7z"
              />
            </svg>
          </div>
          <h3 class="card-title">
            Aplicaciones UNC
          </h3>
          <p class="card-text">
            Accedé a Guaraní, GDE, Portal del Empleado, Google Workspace, y otras aplicaciones utilizando tu Usuario
            UNC.
          </p>
        </div>
      </div>
    </div>

    <div
      ref="divider"
      class="section-divider"
    >
      <div
        ref="dividerDark"
        class="divider-img divider-img-pabellon divider-img--dark"
      />
      <div
        ref="dividerLight"
        class="divider-img divider-img-pabellon divider-img--light"
      />
    </div>

    <div
      ref="stepsSection"
      class="steps-section"
    >
      <div
        ref="stepsBg"
        class="steps-bg"
        aria-hidden="true"
      />
      <div class="steps-inner">
        <div class="section-label reveal-text">
          ¿Cómo crear mi Usuario UNC?
        </div>
        <h2 class="section-title reveal-text">
          Cuatro pasos, sin complicaciones
        </h2>
        <p class="section-desc reveal-text">
          Te guiaremos paso a paso. Solo llevará unos minutos.
        </p>

        <div class="steps-grid">
          <div
            v-for="(step, index) in registerSteps"
            :key="step.title"
            class="step"
          >
            <div class="step-num">
              0{{ index + 1 }}
            </div>
            <h3 class="step-title">
              {{ step.title }}
            </h3>
            <p class="step-text">
              {{ step.text }}
            </p>
          </div>
        </div>

        <div class="hero-btns">
          <cta-button @click="createUser">
            Crear mi Usuario UNC
          </cta-button>
        </div>
      </div>
    </div>

    <div
      id="faq"
      class="section"
    >
      <div class="faq-header">
        <div class="section-label reveal-text">
          Preguntas frecuentes
        </div>
        <h2 class="section-title reveal-text">
          Todo lo que necesitás saber
        </h2>
      </div>
      <div v-if="faqs.length > 0">
        <div
          class="faq-list"
        >
          <div
            v-for="(faq, index) in faqs"
            :key="faq.key"
            class="faq-item"
          >
            <h3 class="faq-question-heading">
              <button
                type="button"
                class="faq-question"
                :class="{ open: isFaqOpen(faq.key) }"
                :aria-expanded="isFaqOpen(faq.key) ? 'true' : 'false'"
                :aria-controls="'faq-answer-' + index"
                @click="toggleFaq(faq.key)"
              >
                <highlighted-text :parts="faq.questionSegments" />
                <span
                  class="faq-icon"
                  :class="{ open: isFaqOpen(faq.key) }"
                  aria-hidden="true"
                />
              </button>
            </h3>
            <transition
              @enter="onEnter"
              @after-enter="onAfterEnter"
              @leave="onLeave"
            >
              <div
                v-if="isFaqOpen(faq.key)"
                :id="'faq-answer-' + index"
                class="faq-answer"
              >
                <highlighted-text :parts="faq.answerSegments" />
              </div>
            </transition>
          </div>
        </div>

        <div class="faq-link-wrapper">
          <router-link
            to="/preguntas-frecuentes"
            class="faq-link reveal-text"
          >
            <span>Ver todas las preguntas frecuentes</span>
            <svg
              aria-hidden="true"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </router-link>
        </div>
      </div>
      <div
        v-else-if="isLoadingFaqs"
        class="faq-list no-faqs"
      >
        Cargando preguntas frecuentes...
      </div>
      <div
        v-else-if="hasFaqsError"
        class="faq-list no-faqs"
      >
        No pudimos cargar las preguntas frecuentes en este momento
      </div>
      <div
        v-else
        class="faq-list no-faqs"
      >
        Todavía no hay preguntas frecuentes destacadas
      </div>
    </div>

    <div
      class="contact-section"
    >
      <div class="section-label reveal-text">
        ¿Necesitás ayuda?
      </div>
      <h2 class="section-title reveal-text">
        Contactanos
      </h2>
      <p class="contact-desc reveal-text">
        Ante cualquier duda, escribí al administrador de tu dependencia o facultad para obtener atención personalizada.
      </p>

      <div class="hero-btns">
        <cta-button
          class="reveal-text contact-cta"
          @click="goToContacts"
        >
          Ver contactos de dependencias
        </cta-button>
      </div>
    </div>
  </div>
</template>

<script>
import { HttpFRONT } from '@/share';
import { mapGetters } from 'vuex';
import { prepareFaq } from '@/utils/richText';
import { collapse, expand, settle } from '@/utils/collapse';
import HighlightedText from '../utils/highlighted-text.vue';
import CtaButton from './cta-button.vue';
import { REGISTER_STEPS } from '../../../server/seo/register-steps';

const REVEAL_SELECTOR = '.reveal-text, .info-card, .faq-item';
const CARD_STAGGER_MS = 150;
const ANSWER_MARGIN = '12px';
const SCROLL_INDICATOR_LIMIT = 100;

function scrollIndicatorStyle (scrollY) {
    const fadeStart = 8;
    const fadeEnd = 90;
    const normalized = (scrollY - fadeStart) / (fadeEnd - fadeStart);
    const progress = Math.max(0, Math.min(1, normalized));
    const opacity = 1 - progress;
    const translateY = progress * 10;

    return {
        opacity: opacity.toFixed(3),
        transform: `translateY(${translateY.toFixed(2)}px)`,
        pointerEvents: opacity < 0.02 ? 'none' : 'auto',
    };
}

export default {
    name: 'LandingPage',
    components: {
        CtaButton,
        HighlightedText,
    },
    data () {
        return {
            registerSteps: REGISTER_STEPS,
            scrollHandler: null,
            scrollFrame: null,
            lastAppliedScrollY: null,
            isIOSDevice: false,
            revealObserver: null,
            isLoadingFaqs: true,
            hasFaqsError: false,
            openFaqKeys: [],
        };
    },
    computed: {
        ...mapGetters([
            'starredFaqs',
        ]),
        faqs () {
            return this.starredFaqs.map((faq, index) => ({
                ...prepareFaq(faq),
                key: `${index}-${faq.question}`,
            }));
        },
    },
    watch: {
        faqs () {
            this.$nextTick(this.observeRevealTargets);
        },
    },
    async mounted () {
        const userAgent = window.navigator.userAgent || '';
        const platform = window.navigator.platform || '';
        const hasTouchPoints = typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 0;
        this.isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) || (platform === 'MacIntel' && hasTouchPoints);

        this.initReveal();
        this.initParallax();

        await this.getStarredFaqs();
    },
    beforeDestroy () {
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler);
        }

        if (this.scrollFrame) {
            window.cancelAnimationFrame(this.scrollFrame);
        }

        this.lastAppliedScrollY = null;

        if (this.revealObserver) {
            this.revealObserver.disconnect();
        }
    },
    methods: {
        createUser () {
            this.$router.push({ path: '/registro' });
        },
        goToContacts () {
            this.$router.push({ path: '/contactos' });
        },
        async getStarredFaqs () {
            try {
                this.isLoadingFaqs = this.starredFaqs.length === 0;
                const response = await HttpFRONT.get('starred-faqs');
                if (response && response.data) {
                    this.$store.commit('setStarredFaqs', response.data);
                }
                this.hasFaqsError = false;
            } catch (error) {
                this.hasFaqsError = this.starredFaqs.length === 0;
                console.warn('No se pudieron cargar las preguntas frecuentes destacadas:', error?.message);
            } finally {
                this.isLoadingFaqs = false;
            }
        },
        isFaqOpen (key) {
            return this.openFaqKeys.includes(key);
        },
        toggleFaq (key) {
            const index = this.openFaqKeys.indexOf(key);

            if (index === -1) {
                this.openFaqKeys.push(key);
                return;
            }

            this.openFaqKeys.splice(index, 1);
        },
        onEnter (el) {
            expand(el, ANSWER_MARGIN);
        },
        onAfterEnter (el) {
            settle(el);
        },
        onLeave (el) {
            collapse(el, ANSWER_MARGIN);
        },
        onCardTilt (event) {
            const card = event.currentTarget;
            const rect = card.getBoundingClientRect();
            const x = (event.clientX - rect.left) / rect.width;
            const y = (event.clientY - rect.top) / rect.height;

            card.style.setProperty('--rotate-y', `${((x - 0.5) * 15).toFixed(2)}deg`);
            card.style.setProperty('--rotate-x', `${(-(y - 0.5) * 10).toFixed(2)}deg`);
        },
        resetCardTilt (event) {
            const card = event.currentTarget;
            card.style.removeProperty('--rotate-x');
            card.style.removeProperty('--rotate-y');
        },
        initReveal () {
            if (typeof IntersectionObserver === 'undefined') {
                this.revealAll();
                return;
            }

            this.revealObserver = new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        if (!entry.isIntersecting) return;

                        this.revealElement(entry.target);
                        this.revealObserver.unobserve(entry.target);
                    });
                },
                { threshold: 0.05, rootMargin: '0px' },
            );

            this.observeRevealTargets();
        },
        revealAll () {
            if (!this.$el) return;

            this.$el.querySelectorAll(REVEAL_SELECTOR).forEach(element => {
                element.classList.add('visible');
            });
        },
        observeRevealTargets () {
            if (!this.$el || !this.revealObserver) return;

            this.$el.querySelectorAll(REVEAL_SELECTOR).forEach(element => {
                if (!element.classList.contains('visible')) {
                    this.revealObserver.observe(element);
                }
            });
        },
        revealElement (element) {
            if (element.classList.contains('info-card')) {
                const cards = Array.from(this.$el.querySelectorAll('.info-card'));
                const delay = Math.max(0, cards.indexOf(element)) * CARD_STAGGER_MS;

                if (delay) {
                    element.style.transitionDelay = `${delay}ms`;
                    element.addEventListener(
                        'transitionend',
                        () => { element.style.transitionDelay = ''; },
                        { once: true },
                    );
                }
            }

            element.classList.add('visible');
        },
        initParallax () {
            const hero = this.$refs.hero;
            const escudo = this.$refs.escudo;
            const heroContent = this.$refs.heroContent;
            const stepsSection = this.$refs.stepsSection;
            const divider = this.$refs.divider;
            const dividerDark = this.$refs.dividerDark;
            const dividerLight = this.$refs.dividerLight;
            const stepsBg = this.$refs.stepsBg;
            const scrollIndicator = this.$refs.scrollIndicator;
            let appliedIndicatorScrollY = null;

            const updateParallax = () => {
                const scrollY = Math.max(0, window.pageYOffset || window.scrollY || 0);
                const delta = this.lastAppliedScrollY === null ? Infinity : Math.abs(scrollY - this.lastAppliedScrollY);

                const indicatorScrollY = Math.min(scrollY, SCROLL_INDICATOR_LIMIT);
                if (scrollIndicator && appliedIndicatorScrollY !== indicatorScrollY) {
                    appliedIndicatorScrollY = indicatorScrollY;
                    Object.assign(scrollIndicator.style, scrollIndicatorStyle(indicatorScrollY));
                }

                this.scrollFrame = null;

                if (this.isIOSDevice && delta < 0.35) {
                    return;
                }

                this.lastAppliedScrollY = scrollY;

                const viewportHeight = window.innerHeight;
                const heroActive = Boolean(hero) && scrollY < hero.offsetHeight;

                const skipSections = heroActive && this.isIOSDevice;
                const stepsRect = !skipSections && stepsSection && stepsBg ? stepsSection.getBoundingClientRect() : null;
                const dividerRect = !skipSections && divider && dividerDark && dividerLight
                    ? divider.getBoundingClientRect()
                    : null;

                if (heroActive) {
                    escudo.style.transform = `translate3d(0, ${scrollY * 0.4}px, 0) rotate(${scrollY * 0.02}deg)`;
                    heroContent.style.transform = `translate3d(0, ${scrollY * 0.2}px, 0)`;
                    heroContent.style.opacity = Math.max(0, 1 - scrollY / 500);
                }

                if (stepsRect) {
                    const inWorkRange = stepsRect.top < viewportHeight * 1.2 && stepsRect.bottom > -viewportHeight * 0.2;

                    if (inWorkRange) {
                        const progress = (viewportHeight - stepsRect.top) / (viewportHeight + stepsRect.height);

                        if (progress > 0 && progress < 1) {
                            const positionY = 50 + (progress - 0.5) * 10;
                            stepsBg.style.transform = `translate(-25%, ${-positionY / 2}%)`;
                        }
                    }
                }

                if (dividerRect) {
                    const inWorkRange = dividerRect.top < viewportHeight * 1.1 && dividerRect.bottom > -viewportHeight * 0.1;

                    if (inWorkRange) {
                        const rawProgress = (viewportHeight - dividerRect.top) / (viewportHeight + dividerRect.height);
                        const progress = Math.max(0, Math.min(1, rawProgress));
                        const startOffset = 180;
                        const mergeTargetProgress = 0.10;
                        const acceleratedProgress = Math.min(progress / mergeTargetProgress, 1);
                        const eased = 1 - Math.pow(1 - acceleratedProgress, 2);
                        const darkOffsetX = (1 - eased) * startOffset;
                        const lightOffsetX = (1 - eased) * (startOffset * 0.8);

                        dividerDark.style.transform = `translate(calc(-50% + ${darkOffsetX}px), -50%)`;
                        dividerLight.style.transform = `translate(calc(-50% + ${lightOffsetX}px), -50%)`;
                    }
                }
            };

            const onScroll = () => {
                if (this.scrollFrame) {
                    return;
                }

                this.scrollFrame = window.requestAnimationFrame(updateParallax);
            };

            this.scrollHandler = onScroll;
            updateParallax();
            window.addEventListener('scroll', this.scrollHandler, { passive: true });
        },
    },
};
</script>

<style scoped>
/* El body queda en Roboto por app-core.css, así que la fuente se declara acá,
   igual que en las raíces de contactos y preguntas frecuentes. */
.landing-root {
  font-family: var(--font-body);
}

.hero {
  --focus-ring: var(--focus-ring-on-dark);
  position: relative;
  min-height: 100vh;
  min-height: 100svh;
  background: linear-gradient(140deg, #001e3c 0%, #003865 50%, #005a9e 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-align: center;
  padding: 60px 24px;
}

.hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 75% 40%, rgba(0, 90, 158, 0.5) 0%, transparent 55%),
    radial-gradient(ellipse at 15% 70%, rgba(159, 3, 145, 0.15) 0%, transparent 50%);
  animation: pulseGlow 8s ease-in-out infinite;
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 680px;
  transition: opacity 0.3s ease;
  will-change: transform, opacity;
}

.hero-escudo {
  position: absolute;
  left: -5px;
  top: 50%;
  width: 600px;
  height: 600px;
  margin-top: -300px;
  transform: translate3d(0, 0, 0);
  pointer-events: none;
  will-change: transform;
  backface-visibility: hidden;
}

.hero-escudo-inner {
  width: 100%;
  height: 100%;
  background-image: url('/src/assets/img/logoUNC.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.1;
  animation: floatEscudo 20s ease-in-out infinite;
}

.hero-scroll-indicator {
  position: absolute;
  inset: auto 0 60px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: fit-content;
  color: rgba(255, 255, 255, 0.4);
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  z-index: 3;
  animation: bounce 2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transition: opacity 0.18s ease-out, transform 0.18s ease-out;
  will-change: transform;
}

.hero-scroll-indicator .scroll-line {
  width: 2px;
  height: 50px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
  transform-origin: top;
  animation: scrollLine 3.5s ease-in-out infinite;
}

.hero-institutional {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  margin-bottom: 28px;
  animation: fadeUp 0.8s ease both;
}

.hero-inst-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--unc-verde-light);
  flex-shrink: 0;
  animation: pulse 2s ease-in-out infinite;
}

.hero-inst-dot:last-child {
  animation-delay: 1s;
}

.hero-logo {
  font-family: var(--font-display);
  font-size: clamp(42px, 8vw, 72px);
  font-weight: 700;
  color: white;
  line-height: 1.1;
  margin-bottom: 8px;
  margin-top: 0;
  animation: fadeUp 0.8s ease 0.15s both;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.hero-logo span {
  color: var(--unc-verde-light);
  position: relative;
  display: inline-block;
  animation: glowText 3s ease-in-out infinite;
}

.hero-subtitle {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 300;
  line-height: 1.6;
  margin-bottom: 40px;
  animation: fadeUp 0.8s ease 0.3s both;
}

.hero-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.reveal-text {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
    transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.reveal-text.visible {
  opacity: 1;
  transform: translateY(0);
}

.section {
  padding: 100px 24px;
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
}

.section-label {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--unc-azul-light);
  margin-bottom: 12px;
}

.section-title {
  font-family: var(--font-display);
  font-size: clamp(28px, 5vw, 44px);
  font-weight: 700;
  color: var(--unc-azul);
  line-height: 1.2;
  margin-bottom: 16px;
  margin-top: 0;
}

.section-desc {
  font-size: 18px;
  color: var(--text-muted);
  font-weight: 300;
  max-width: 560px;
  line-height: 1.7;
}

.section-divider {
  position: relative;
  height: 200px;
  overflow: hidden;
  background: linear-gradient(to bottom, var(--bg) 50%, #003865 50%);
}

.divider-img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 500px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  /* Suaviza el deslizamiento: la curva del JS concentra casi todo el
     movimiento en el primer 10% del recorrido y sin esto se ve un salto. */
  transition: transform 0.3s ease-out;
  will-change: transform;
  backface-visibility: hidden;
}

.divider-img-pabellon {
  background-image: url('/src/assets/img/pabellon.png');
}

.divider-img--dark {
  clip-path: inset(50% 0 0 0);
  filter: brightness(0) invert(1);
}

.divider-img--light {
  clip-path: inset(0 0 50% 0);
  filter: brightness(0) saturate(100%) invert(18%) sepia(80%) saturate(800%) hue-rotate(190deg);
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 60px;
}

.info-card {
  --rotate-x: 0deg;
  --rotate-y: 0deg;
  --reveal-y: 40px;
  --reveal-scale: 0.95;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 36px 28px;
  opacity: 0;
  transform: perspective(1000px) rotateY(var(--rotate-y)) rotateX(var(--rotate-x)) translateY(var(--reveal-y)) scale(var(--reveal-scale));
  transition: opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1),
    transform 0.6s cubic-bezier(0.16, 1, 0.3, 1),
    box-shadow 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.info-card.visible {
  opacity: 1;
  --reveal-y: 0px;
  --reveal-scale: 1;
}

.info-card.visible:hover {
  --reveal-y: -8px;
}

.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(0, 56, 101, 0.08), rgba(62, 182, 184, 0.08));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  transition: transform 0.3s ease;
}

.card-icon svg {
  width: 24px;
  height: 24px;
  color: var(--unc-azul-mid);
  transition: color 0.3s ease;
}

.card-title {
  font-family: var(--font-display);
  font-size: 21px;
  color: var(--unc-azul);
  margin-bottom: 12px;
  margin-top: 0;
  font-weight: 400;
  line-height: 1.42857143;
}

.card-text {
  font-size: 16px;
  color: var(--text-muted);
  line-height: 1.8;
  font-weight: 300;
}

.steps-section {
  --focus-ring: var(--focus-ring-on-dark);
  padding: 100px 24px;
  position: relative;
  overflow: hidden;
}

.steps-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  background: linear-gradient(140deg, #001e3c 0%, #003865 60%, #004f8c 100%);
  transition: transform 0.3s ease;
  will-change: transform;
  pointer-events: none;
}

.steps-inner {
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.steps-section .section-title {
  color: white;
}

.steps-section .section-label {
  color: #7ec8f4;
}

.steps-section .section-desc {
  color: rgba(255, 255, 255, 0.45);
}

.steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-top: 60px;
  margin-bottom: 60px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 28px;
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
  border-bottom: var(--unc-verde-light) 3px solid;
}

.step:hover {
  transform: translateY(-4px);
}

.step-num {
  font-family: var(--font-display);
  font-size: 80px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--unc-verde-light), #7ec8f4);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  opacity: 0.7;
  line-height: 1.2;
  margin-bottom: 12px;
}

.step-title {
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin-bottom: 10px;
  margin-top: 0;
  line-height: 1.42857143;
}

.step-text {
  font-size: 17px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.7;
  font-weight: 300;
}

#faq {
  overflow-x: clip;
}

.faq-header {
  text-align: center;
}

.faq-header .section-title {
  margin: 0 auto;
}

.faq-link-wrapper {
  text-align: center;
}

.faq-list {
  padding: 0px 24px;
  z-index: 1;
  position: relative;
  background: rgba(255, 255, 255, 0.9);
  overflow: hidden;
  border-radius: 20px;
  margin-bottom: 30px;
  margin-top: 50px;
  border: 1px solid rgba(0, 56, 101, 0.1);
  box-shadow: 0 8px 32px rgba(0, 56, 101, 0.08);
}

.faq-item {
  border-bottom: 1px solid rgba(0, 56, 101, 0.08);
  padding: 16px 0;
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  opacity: 0;
  transform: translateY(20px);
}

.faq-item.visible {
  opacity: 1;
  transform: translateY(0);
}

.faq-item:last-child {
  border-bottom: none;
}

.faq-question-heading {
  margin: 0;
  font: inherit;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-weight: 600;
  color: var(--unc-azul);
  font-size: 16px;
  gap: 16px;
  transition: color 0.3s ease;
  padding: 4px 0;
  width: 100%;
  text-align: left;
  background: none;
  border: 0;
  appearance: none;
  -webkit-appearance: none;
}

.faq-question:hover {
  color: var(--unc-azul-light);
}

.faq-question.open {
  color: var(--unc-azul-light);
}

.faq-icon {
  position: relative;
  color: var(--unc-azul-light);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), background 0.3s ease, color 0.3s ease;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 56, 101, 0.05);
}

.faq-icon::before,
.faq-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  background: currentColor;
  border-radius: 1px;
  transform: translate(-50%, -50%);
}

.faq-icon::before {
  width: 10px;
  height: 2px;
}

.faq-icon::after {
  width: 2px;
  height: 10px;
}

.faq-icon.open {
  transform: rotate(45deg);
  background: var(--unc-verde-light);
  color: white;
}

.faq-answer {
  margin-top: 12px;
  padding-right: 40px;
  font-size: 15px;
  color: var(--text-muted);
  line-height: 1.8;
  white-space: pre-line;
  opacity: 1;
}

.faq-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  color: var(--unc-azul-light);
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 12px 24px;
  border-radius: 100px;
  background: rgba(0, 56, 101, 0.05);
}

.faq-link:hover {
  transform: translateY(-4px);
  background: rgba(0, 56, 101, 0.1);
}

.faq-link svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.faq-link:hover svg {
  transform: translateX(4px);
}

.no-faqs {
  padding-top: 100px;
  padding-bottom: 100px;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 60px;
  color: var(--text-muted);
  font-size: 18px;
}

.contact-section {
  --focus-ring: var(--focus-ring-on-dark);
  background: linear-gradient(140deg, #001e3c 0%, #003865 100%);
  padding: 100px 24px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.contact-section::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 50% 50%, rgba(62, 182, 184, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.contact-section > * {
  position: relative;
  z-index: 1;
}

.contact-section .section-title {
  color: white;
}

.contact-section .section-label {
  color: #7ec8f4;
}

.contact-cta {
  margin-top: 15px;
}

.contact-desc {
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  font-weight: 300;
  margin-top: 16px;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.8;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(15px);
  }

  100% {
    transform: translateY(0);
  }
}

@keyframes scrollLine {

  0%,
  100% {
    transform: scaleY(1);
    opacity: 0.3;
  }

  50% {
    transform: scaleY(1.5);
    opacity: 0.6;
  }
}

@keyframes pulseGlow {

  0%,
  100% {
    opacity: 0.5;
  }

  50% {
    opacity: 0.8;
  }
}

@keyframes floatEscudo {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }

  25% {
    transform: translateY(-2%) translateX(-10px);
  }

  50% {
    transform: translateY(2%) translateX(10px);
  }

  75% {
    transform: translateY(-1%) translateX(-5px);
  }
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

@keyframes glowText {

  0%,
  100% {
    text-shadow: 0 0 20px rgba(62, 182, 184, 0.3);
  }

  50% {
    text-shadow: 0 0 40px rgba(62, 182, 184, 0.6);
  }
}

@media (max-width: 900px) {
  .steps-grid {
    gap: 16px;
  }

  .step {
    padding: 20px;
  }
}

@media (max-width: 600px) {
  .hero {
    padding: 0px 20px calc(88px + env(safe-area-inset-bottom));
  }

  .hero-escudo {
    width: 400px;
    height: 400px;
    margin-top: -200px;
  }

  .hero-escudo-inner {
    opacity: 0.03;
  }

  .hero::before,
  .hero-escudo-inner,
  .hero-logo span {
    animation: none;
  }

  .section {
    padding: 60px 20px;
  }

  .cards-grid {
    gap: 20px;
  }

  .step-num {
    font-size: 60px;
  }

  .hero-institutional {
    margin-bottom: 22px;
  }

  .hero-logo {
    margin-top: 50px;
    margin-bottom: 16px;
  }

  .hero-subtitle {
    margin-bottom: 32px;
  }

  .hero-btns {
    margin-top: 50px;
    flex-direction: column;
    gap: 14px;
    align-items: stretch;
  }

  .hero-scroll-indicator {
    inset: auto 0 calc(40px + env(safe-area-inset-bottom)) 0;
    margin: 0 auto;
    width: fit-content;
  }

  .divider-img-pabellon {
    width: 350px;
    height: 350px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal-text,
  .info-card,
  .faq-item {
    opacity: 1;
    transform: none;
    transition: none;
  }

  .hero::before,
  .hero-escudo-inner,
  .hero-scroll-indicator,
  .hero-scroll-indicator .scroll-line,
  .hero-inst-dot,
  .hero-logo span {
    animation: none;
  }
}

</style>
